module.exports = __webpack_public_path__ + "static/media/mainimg-01.ee9ec173.png";